import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { toast } from 'react-toastify';

import { SubmitButton } from 'components';
import { InviteUsersForm } from 'forms';
import { UsersInvitedDialog } from 'dialogs/user';
import { useAppDispatch } from 'store/store.hook';
import { updateLayout } from 'store/slices/layout.slice';

export const ProfileInviteUsersPage = () => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const formRef = useRef<any>();
  const [{ visibleUsersInvitedDialog, succeed, failed }, setUserInvitedResult] = useState<{
    visibleUsersInvitedDialog: boolean;
    succeed: string[];
    failed: string[];
  }>({
    visibleUsersInvitedDialog: false,
    succeed: [],
    failed: [],
  });
  const submitButtonLabel = down_sm ? 'Invite' : 'Invite User';

  useEffect(() => {
    dispatch(updateLayout({ headerTitle: 'Invite User' }));
  }, []);

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <>
      <Box>
        <Typography variant="h5">Invite Users</Typography>

        <Typography sx={{ fontWeight: 'normal', marginTop: 1, marginBottom: 4, color: theme.palette.text.secondary }}>
          Invite the team, and get to work.
        </Typography>

        <InviteUsersForm
          ref={formRef}
          onLoading={(loading) => setLoading(loading)}
          next={(data) => {
            const { succeed = [], failed = [] } = data;

            const { length } = [...succeed, ...failed];

            if (length > 1) {
              setUserInvitedResult((prev) => ({ ...prev, visibleUsersInvitedDialog: true, succeed, failed }));
            }

            if (length === 1) {
              if (succeed.length === 1) {
                toast.success(`Successfully sent an email to invite user - ${succeed[0]}`);
              } else {
                toast.error(`The email ${failed[0]} was already registered in the system.`);
              }
            }
          }}
        />

        <SubmitButton loading={loading} label={submitButtonLabel} onClick={onSubmit} sx={{ marginTop: 6 }} />
      </Box>

      <UsersInvitedDialog
        visible={visibleUsersInvitedDialog}
        setVisible={(visibleUsersInvitedDialog) =>
          setUserInvitedResult((prev) => ({ ...prev, visibleUsersInvitedDialog }))
        }
        succeed={succeed}
        failed={failed}
      />
    </>
  );
};
